import { render, staticRenderFns } from "./Alerted.vue?vue&type=template&id=480ec812&lang=pug&"
import script from "./Alerted.vue?vue&type=script&lang=js&"
export * from "./Alerted.vue?vue&type=script&lang=js&"
import style0 from "./Alerted.vue?vue&type=style&index=0&id=480ec812&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports